import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule, MatIconModule } from '@angular/material';
import { ShowHistoryDialogComponent } from './show-history-dialog.component';

@NgModule({
	declarations: [ShowHistoryDialogComponent],
	imports: [CommonModule, MatIconModule, MatDividerModule],
	entryComponents: [ShowHistoryDialogComponent],
	exports: [ShowHistoryDialogComponent]
})
export class ShowHistoryDialogModule {}
